export type LoadingState = number;
export const LoadingStateLoading = 0;
export const LoadingStateHasData = 1;
export const LoadingStateNoData = 2;

export enum LoadingStateV2 {
  Unknown = 0,
  Loading = 1,
  DataRetrieved = 2,
  NoDataRetrieved = 3,
}

export function isLoading(src: LoadingStateV2): boolean {
  return src === LoadingStateV2.Loading;
}

export function hasData(src: LoadingStateV2): boolean {
  return src === LoadingStateV2.DataRetrieved;
}

export function noData(src: LoadingStateV2): boolean {
  return src === LoadingStateV2.NoDataRetrieved;
}
